export default __webpack_public_path__ + "3448122f47d42820e9c341d3fee4e2ed.png";